import ForestOutlinedIcon from '@mui/icons-material/ForestOutlined';
import type {SxProps} from '@mui/material';
import Button from '@mui/material/Button';
import type {FC} from 'react';
import {useTranslation} from 'react-i18next';

//TYPES
type Props = {
  onUploadInventoryPlot: (file?: File) => void;
  disabled: boolean;
};

const PlotInventoriesUploadForm: FC<Props> = ({onUploadInventoryPlot, disabled}) => {
  const {t} = useTranslation();

  return (
    <Button
      component="label"
      startIcon={<ForestOutlinedIcon />}
      variant="outlined"
      onClick={() => {}}
      sx={styles.uploadingButon}
      disabled={disabled}
    >
      {t('inventoryPlots.title')}
      <input
        type="file"
        accept={'application/zip'}
        onChange={(event) => onUploadInventoryPlot(event.target.files?.[0])}
        hidden
      />
    </Button>
  );
};
export default PlotInventoriesUploadForm;

const styles: Record<string, SxProps> = {
  uploadingButon: {
    mb: '0.75rem',
    color: 'primary.main',
    backgroundColor: 'common.white',
    boxShadow: 0,
  },
};
